/* MoRetro Studio V27 - Workshop production read model. Production is display-only. */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const cfg = MTS.WorkshopConfig;
  const h = cfg.h;

  function projectPrinterName(project = {}){
    return String(
      project.printerName ||
      project.printer ||
      project.productionPrinter ||
      project.autoQuote?.analysis?.metadata?.printer ||
      project.autoQuote?.settings?.printer ||
      project.quote?.printerName ||
      ""
    ).trim();
  }

  function matchesPrinter(project = {}, printer = {}){
    const wantedId = String(printer.id || "").toLowerCase();
    const wantedName = String(printer.name || "").toLowerCase();
    const projectPrinterId = String(project.printerId || project.productionPrinterId || project.autoQuote?.settings?.printerId || "").toLowerCase();
    const projectPrinter = projectPrinterName(project).toLowerCase();

    if(wantedId && projectPrinterId && wantedId === projectPrinterId) return true;
    if(wantedName && projectPrinter && wantedName === projectPrinter) return true;
    if(wantedName && projectPrinter && projectPrinter.includes(wantedName)) return true;
    return false;
  }

  function activeProjects(){
    const projects = Array.isArray(MTS.state?.projects) ? MTS.state.projects : [];
    return projects.filter(p=>cfg.PRODUCTION_STATUSES.includes(p.status || "new"));
  }

  function assignedProject(printer){
    const projects = activeProjects().filter(p=>matchesPrinter(p, printer));
    const order = {printing:1, finishing:2, paid:3, ready:4};
    return projects.sort((a,b)=>(order[a.status] || 99) - (order[b.status] || 99))[0] || null;
  }

  function unassignedProjects(){
    return activeProjects().filter(p=>!projectPrinterName(p));
  }

  function machineIsOnline(printer = {}, telemetry = {}){
    if(telemetry.online === true) return true;
    if(telemetry.online === false) return false;
    if(printer.connectorStatus === "online") return true;
    if(printer.connectorStatus === "offline") return false;
    if(printer.lastConnectionStatus === "online") return true;
    return false;
  }

  function normalizedMachineState(telemetry = {}){
    const state = String(telemetry.state || "").trim().toLowerCase();
    if(["running", "printing", "print", "prepare", "slicing"].includes(state)) return "printing";
    if(["pause", "paused", "pausing"].includes(state)) return "paused";
    if(["finish", "finished", "complete", "completed"].includes(state)) return "finished";
    if(["idle", "ready", "standby"].includes(state)) return "idle";
    if(["offline", "disconnected", "unknown"].includes(state)) return "offline";
    return state;
  }

  function statusClass(project, printer){
    const t = MTS.WorkshopUI?.machineTelemetry?.(printer || {}) || printer || {};
    const machineState = normalizedMachineState(t);
    if(printer?.manualStatus === "maintenance") return "maintenance";
    if(printer?.manualStatus === "offline") return "offline";
    if(!machineIsOnline(printer, t)) return "offline";
    if(project || machineState === "printing" || machineState === "paused") return "occupied";
    return "free";
  }

  function statusLabel(project, printer){
    const t = MTS.WorkshopUI?.machineTelemetry?.(printer || {}) || printer || {};
    const machineState = normalizedMachineState(t);
    if(printer?.manualStatus === "maintenance") return "Maintenance";
    if(printer?.manualStatus === "offline") return "Hors ligne";
    if(!machineIsOnline(printer, t)) return "Hors ligne";
    if(machineIsOnline(printer, t)){
      if(machineState === "printing") return "En impression";
      if(machineState === "paused") return "En pause";
      if(machineState === "finished") return "Terminee";
      if(machineState) return "Libre";
    }
    if(!project) return "Libre";
    if(MTS.statusLabel) return MTS.statusLabel(project.status || "new");
    return project.status || "Reservee";
  }

  function projectPrice(project = {}){
    return Number(
      project.finalPrice ||
      project.quoteTotal ||
      project.quote?.final ||
      project.quote?.total ||
      project.autoQuote?.quote?.final ||
      project.autoQuote?.quote?.suggested ||
      0
    );
  }

  function printTime(project = {}){
    const minutes = Number(project.printEstimatedMinutes || 0);
    const hours = Number(project.autoQuote?.quote?.printHours || project.quote?.printHours || 0);
    const totalMinutes = minutes || Math.round(hours * 60);
    if(!totalMinutes) return "Temps non renseigne";
    const hh = Math.floor(totalMinutes / 60);
    const mm = totalMinutes % 60;
    return `${hh}h${String(mm).padStart(2,"0")}`;
  }

  function filamentName(project = {}){
    return String(
      project.filamentName ||
      project.materialName ||
      project.autoQuote?.analysis?.metadata?.filamentName ||
      project.autoQuote?.analysis?.metadata?.filament ||
      project.autoQuote?.settings?.material ||
      "Non renseigne"
    );
  }

  MTS.WorkshopProduction = {
    projectPrinterName,
    matchesPrinter,
    activeProjects,
    assignedProject,
    unassignedProjects,
    machineIsOnline,
    normalizedMachineState,
    statusClass,
    statusLabel,
    projectPrice,
    printTime,
    filamentName
  };
})(window.MTS);
